import { DocumentSnapshot } from '@firebase/firestore-types'

export class Season{
  public static of(s:DocumentSnapshot):Season{
    return {
      id: s.id,
      data: s.data() as SeasonData
    }
  }

  id: string;
  data: SeasonData;

}

export class SeasonData{
  name: string;
  start: Date;
  end: Date;
}
